module.exports = __webpack_public_path__ + "img/gdzbzz.043b1f8.png";